import { Flex, Text } from '@radix-ui/themes';
import { LegendDot } from 'components/sections/analytics/session-hits/recap/legend-dot';
import { SESSION_HIT_RESULT_COLORS } from 'enums/session-recap/colors';
import {
  SESSION_HIT_RESULT_LABELS,
  SessionHitResult,
} from 'enums/session-recap/enums';
import { t } from 'i18next';

export const ResultBadge = (props: {
  result: SessionHitResult | undefined;
  size?: '1' | '2' | '3' | '5';
  weight?: 'regular' | 'medium' | 'bold';
}) => {
  if (!props.result) {
    return <Text size={props.size}>-</Text>;
  }

  return (
    <Flex gap="2" align="center">
      <LegendDot color={SESSION_HIT_RESULT_COLORS[props.result]} />
      <Text size={props.size} weight={props.weight} truncate>
        {t(SESSION_HIT_RESULT_LABELS[props.result])}
      </Text>
    </Flex>
  );
};
